import { useEffect, useState } from "react";

import { CookieNotice } from "components/widgets";
import { loadCookieNotice, setCookieNotice } from "utils/storage";

export const CookieNoticeWrapper = (): JSX.Element => {
  const [show, setShow] = useState<boolean>(false);

  useEffect(() => {
    try {
      const value = loadCookieNotice();

      if (value === null) {
        setShow(true);
      }
    } catch (e) {
      console.error("Local storage not available, not showing the cookie notice.");
    }
  }, []);

  const onOK = () => {
    setCookieNotice("ok");
    setShow(false);
  };

  const onCancel = () => {
    setCookieNotice("cancel");
    setShow(false);
  };

  if (!show) {
    return <></>;
  }

  return (
    <CookieNotice
      onOK={onOK}
      onCancel={onCancel}
    />
  );
};
